/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class STFindResultPanel {
  async GetFindResults(viewId : string, tabId : string, viewState : st.ViewState) : Promise<any> {
    return await componentApi.call('st', 'st-find-result-panel', 'STFindResultPanel', 'GetFindResults', {
      viewId,
      tabId,
      viewState,
    });
  }
}
export default new STFindResultPanel()
